// extracted by mini-css-extract-plugin
export var numpadContainer = "_mp-1";
export var phoneButton = "_mp-0";